import {view, Link} from '@sail/ui';
import {ChatRow} from './ChatRow';
import {AttachmentInfoNext} from './AttachmentInfoNext';

export type Props = {
  name: string;
  size: number;
  url?: string;
  avatar?: React.ReactNode | null | undefined;
  error?: React.ReactNode;
};

export const AttachmentRowNext = ({name, size, url, avatar, error}: Props) => {
  if (url) {
    return (
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        type="secondary"
        css={{
          width: 'fill',
          textDecoration: 'none',
        }}
        data-testid="attachment-link"
      >
        <view.div data-testid="attachment-row">
          <ChatRow avatar={avatar} error={error}>
            <AttachmentInfoNext name={name} size={size} clickable />
          </ChatRow>
        </view.div>
      </Link>
    );
  }

  return (
    <view.div data-testid="attachment-row">
      <ChatRow avatar={avatar} error={error}>
        <AttachmentInfoNext name={name} size={size} />
      </ChatRow>
    </view.div>
  );
};
